import React from 'react'
import { useRouter } from 'next/router'
import { ComingSoonFeature } from '../components/shared/ComingSoonFeature'
import { Flex } from '@chakra-ui/react'
import { IconType } from '../components/Icon'

// Default values for query parameters
export const COMING_SOON_DEFAULTS = {
    title: 'Coming Soon',
    icon: 'analytics' as IconType,
    feature: 'default',
} as const

const ComingSoonPage: React.FC = () => {
    const router = useRouter()
    const { title, icon, feature } = router.query

    // Map of feature-specific calendar links
    const featureCalendarLinks: Record<string, string> = {
        dashboard: 'https://calendar.app.google/HdbbacimFdhNKrZ16',
        fullFunnelCreative: 'https://calendar.app.google/2hcppHj9aZGfbLmN8',
        adCreative: 'https://calendly.com/joel-blackcrow/ad-creative',
        creativeAnalytics: 'https://calendar.app.google/HdbbacimFdhNKrZ16',
        emailCreative: 'https://calendar.app.google/HdbbacimFdhNKrZ16',
        smsCreative: 'https://calendar.app.google/HdbbacimFdhNKrZ16',
        default: 'https://calendar.app.google/HdbbacimFdhNKrZ16',
    }

    // Map of feature-specific descriptions (keep them concise to fit on screen)
    const featureDescriptions: Record<string, string> = {
        dashboard:
            'Get a comprehensive view of your marketing performance across all channels with our analytics dashboard.',
        fullFunnelCreative:
            'Create end-to-end marketing funnels that convert. Build cohesive campaigns that drive results.',
        adCreative:
            'Design high-converting ad creative for Meta platforms with our AI-powered tools.',
        creativeAnalytics:
            'Gain deep insights into your creative performance to optimize your content strategy.',
        emailCreative:
            'Create compelling email campaigns that drive engagement and sales.',
        smsCreative:
            'Craft SMS messages that drive immediate action and get results.',
        default:
            "We're building something amazing for Shopify marketers. Get a sneak peek of this feature.",
    }

    // Map of feature-specific background images
    const featureBackgrounds: Record<string, string> = {
        dashboard: '/coming-soon.png',
        fullFunnelCreative: '/coming-soon.png',
        adCreative: '/ad-creative.png',
        default: '/coming-soon.png',
    }

    // Get the appropriate description based on the feature value
    const getDescription = () => {
        const featureKey =
            typeof feature === 'string'
                ? feature
                : typeof icon === 'string'
                  ? icon
                  : 'default'

        return featureDescriptions[featureKey] || featureDescriptions.default
    }

    // Get the appropriate background image based on the feature value
    const getBackgroundImage = () => {
        const featureKey =
            typeof feature === 'string'
                ? feature
                : typeof icon === 'string'
                  ? icon
                  : 'default'

        return featureBackgrounds[featureKey] || featureBackgrounds.default
    }

    // Get the appropriate calendar link based on the feature value
    const getCalendarLink = () => {
        const featureKey =
            typeof feature === 'string'
                ? feature
                : typeof icon === 'string'
                  ? icon
                  : 'default'

        return featureCalendarLinks[featureKey] || featureCalendarLinks.default
    }

    // Get the feature key for the component
    const getFeatureKey = () => {
        return typeof feature === 'string'
            ? feature
            : typeof icon === 'string'
              ? icon
              : 'default'
    }

    return (
        <Flex direction="column" h="100vh" overflow="hidden" margin="-8">
            <ComingSoonFeature
                title={
                    typeof title === 'string'
                        ? title
                        : COMING_SOON_DEFAULTS.title
                }
                featureIcon={
                    typeof icon === 'string'
                        ? (icon as IconType)
                        : COMING_SOON_DEFAULTS.icon
                }
                calendarLink={getCalendarLink()}
                description={getDescription()}
                backgroundImage={getBackgroundImage()}
                feature={getFeatureKey()}
                buttonText={'Chat with our Product Team'}
            />
        </Flex>
    )
}

export default ComingSoonPage
